import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppBuilderSideBar from './AppBuilderSideBar';
import AppBuilderTopBar from './AppBuilderTopBar';
import AppBuilderInnerSideBar from './AppBuilderInnerSideBar';
import { useLocation, useNavigate, Route, Routes, Navigate, } from 'react-router-dom';
import { AppBuilderWrapper, AppBuilderInnerWrapper, AppBuilderContentOuterWrapper, AppBuilderContentWrapper, StructureBuilderWrapper, AppBuilderModalWrapperInner, AppBuilderPagesWrapper, AppBuilderModalInnerWrapper, } from './styles';
import StructureBuilderPage from '@project/containers/StructureBuilderPage';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectAppDevPlanStatusError, selectAppDevPlanStatusLoading, selectAppDevPlanStatus, } from '../../../store/appDevPlanStatus/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { setAppOpen, selectApp, selectOrganization, } from '@project/containers/Root/actions';
import { selectSelectedApp } from '../../../store/selectedApp/selectors';
import { loadSelectedApp } from '../../../store/selectedApp/actions';
import AppBuilderMenu from './navigation';
import findSelectedMenu from '../../utils/findSelectedMenu/findSelectedMenu';
import { getAppDevPlanStatus } from '../../../store/appDevPlanStatus/actions';
var AppMainLayout = function (props) {
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var pathNameArray = pathname.split('/');
    var orgId = pathNameArray[2];
    var appId = pathNameArray[4];
    var dispatch = useDispatch();
    var selectedApp = useSelector(selectSelectedApp);
    var isAppNotFound = selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.error;
    var _a = useState(false), selectedAppLoadingStarted = _a[0], setSelectedAppLoadingStarted = _a[1];
    var _b = useState(false), loadSelectedAppRanOnce = _b[0], setLoadSelectedAppRanOnce = _b[1];
    var _c = useState(false), statusLoadedOnce = _c[0], setStatusLoadedOnce = _c[1];
    useEffect(function () {
        dispatch(setAppOpen(pathname, appId));
        dispatch(selectApp(appId));
        dispatch(selectOrganization(orgId));
    }, [appId, dispatch, orgId, pathname]);
    useEffect(function () {
        dispatch(loadSelectedApp(appId));
    }, [appId, dispatch]);
    useEffect(function () {
        setSelectedAppLoadingStarted(selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.loading);
        selectedAppLoadingStarted &&
            !(selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.loading) &&
            setLoadSelectedAppRanOnce(true);
    }, [selectedApp, selectedAppLoadingStarted]);
    //==============================GoToConfig===============================
    useEffect(function () {
        if (loadSelectedAppRanOnce) {
            dispatch(getAppDevPlanStatus(selectedApp.app.id));
            setStatusLoadedOnce(true);
        }
    }, [loadSelectedAppRanOnce, selectedApp.app.id, dispatch]);
    var appDevPlanStatus = useSelector(selectAppDevPlanStatus);
    var appDevPlanStatusLoading = useSelector(selectAppDevPlanStatusLoading);
    var appDevPlanStatusError = useSelector(selectAppDevPlanStatusError);
    useEffect(function () {
        if (statusLoadedOnce && appDevPlanStatusLoading === false) {
            !(appDevPlanStatusError === false &&
                (appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.devplan_status) === true &&
                (appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.consumption_status) === true &&
                (appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.payment) === true) && navigate('/config');
        }
    }, [
        appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.devplan_status,
        appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.consumption_status,
        appDevPlanStatus === null || appDevPlanStatus === void 0 ? void 0 : appDevPlanStatus.payment,
        appDevPlanStatusLoading,
        appDevPlanStatusError,
        dispatch,
        statusLoadedOnce,
        navigate,
    ]);
    //==============================GoToConfig===============================
    // ======================find selected menu item ========================
    var AppBuilderMenuItems = AppBuilderMenu(appId, orgId).filter(function (menu) { return menu.id !== 3; });
    var selectedMenu = findSelectedMenu(AppBuilderMenuItems, pathname);
    // ======================!find selected menu item ========================
    return isAppNotFound ? (_jsx(Navigate, { to: "/organizations/".concat(orgId, "/apps") })) : (_jsxs(AppBuilderWrapper, { children: [_jsx(AppBuilderSideBar, { orgId: orgId, appId: appId }), _jsx(AppBuilderInnerWrapper, { children: _jsx(AppBuilderContentOuterWrapper, { children: _jsxs(AppBuilderContentWrapper, { children: [_jsx(AppBuilderTopBar, { app: selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.app, orgId: orgId }), AppBuilderMenuItems.map(function (item) {
                                return item.id === (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.id) ? (_jsx(AppBuilderModalWrapperInner, { children: _jsxs(AppBuilderModalInnerWrapper, { children: [_jsx(AppBuilderInnerSideBar, { orgId: orgId, appId: appId }), _jsx(AppBuilderPagesWrapper, { children: props.children })] }) }, item.id)) : null;
                            }), !selectedMenu && props.children /*To show - not found page*/, _jsx(StructureBuilderWrapper, { children: _jsx(Routes, { children: _jsx(Route, { path: "/:reDirectPatchId/:patchId?", element: _jsx(StructureBuilderPage, {}) }, "StructureBuilderPage") }) })] }) }) }), _jsx(ToastContainer, { enableMultiContainer: true, containerId: 'cms', position: "bottom-right", transition: Slide, autoClose: 4000, closeButton: false, closeOnClick: true, hideProgressBar: true })] }));
};
export default AppMainLayout;
